import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductVerificationAdapter } from './product-verification.adapter';

@Injectable()
export class ProductVerificationConnector {
  constructor(private productVerificationAdapter: ProductVerificationAdapter) {}

  isApplianceOnRecallList(serialNumber: string, applianceCode: string): Observable<boolean> {
    return this.productVerificationAdapter.isApplianceOnRecallList(serialNumber, applianceCode);
  }
}
